export const fmtEur = (v) => (v == null || !isFinite(v) ? "—" : new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(Math.round(v)) + " €");
export const fmtEurS = (v) => (v == null || !isFinite(v) ? "—" : (v >= 0 ? "+" : "−") + fmtEur(Math.abs(v)));
export const fmtPct = (v, d = 1) => (v == null || !isFinite(v) ? "—" : (v * 100).toFixed(d).replace(".", ",") + " %");
export const fmtPctS = (v, d = 1) => (v == null || !isFinite(v) ? "—" : (v >= 0 ? "+" : "−") + fmtPct(Math.abs(v), d));
export const fmtShort = (v) => (v == null || !isFinite(v) ? "—" : Math.abs(v) >= 1e6 ? (v / 1e6).toFixed(1).replace(".", ",") + " M€" : Math.abs(v) >= 1e3 ? Math.round(v / 1e3) + " k€" : Math.round(v) + " €");

export const MONTHS_FR = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
export const MONTHS_UP = ["JANVIER", "FEVRIER", "MARS", "AVRIL", "MAI", "JUIN", "JUILLET", "AOUT", "SEPTEMBRE", "OCTOBRE", "NOVEMBRE", "DECEMBRE"];
const DAYS_FR = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
const MONTHS_ABBR = ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."];

export const dayLabel = (iso) => { const d = new Date(iso + "T00:00:00"); return `${DAYS_FR[d.getDay()]} ${d.getDate()} ${MONTHS_FR[d.getMonth()].toLowerCase()}`; };
export const shortDate = (iso) => { const d = new Date(iso + "T00:00:00"); return `${d.getDate()} ${MONTHS_ABBR[d.getMonth()]}`; };
export const statusOf = (perf) => (perf == null ? null : perf >= 1 ? "avance" : perf >= 0.95 ? "objectif" : "retard");
export const STATUS_CLS = { avance: "bg-emerald-100 text-emerald-700", objectif: "bg-amber-100 text-amber-700", retard: "bg-rose-100 text-rose-700" };
export const signCls = (v) => (v == null ? "text-slate-400" : v >= 0 ? "text-emerald-600" : "text-rose-600");

/* Justesse de l'objectif : indice = (70 % réalisé + 18 % tendance 3 mois + 12 % N-1) / objectif */
export const JUSTESSE_TOOLTIP = "Évalue si l'objectif fixé était cohérent avec le CA finalement réalisé, la tendance des trois derniers mois et le CA N-1.\nFormule simplifiée :\nIndice = (70 % × Réalisé + 18 % × Tendance 3 mois + 12 % × N-1) ÷ Objectif × 100\n≤ 90 % : Sur-estimé\nDe 90 % à 115 % : Réaliste\n≥ 115 % : Sous-estimé";
export function justesse(realise, trend3m, n_1, objectif) {
  if (!objectif || !(realise > 0)) return null;
  const t = trend3m > 0 ? trend3m : realise;
  const n1 = n_1 > 0 ? n_1 : realise;
  const idx = (0.7 * realise + 0.18 * t + 0.12 * n1) / objectif * 100;
  const status = idx <= 90 ? "sur" : idx >= 115 ? "sous" : "ok";
  return { idx, status, label: { sur: "Sur-estimé", ok: "Réaliste", sous: "Sous-estimé" }[status] };
}
export const JUSTESSE_CLS = { sur: "bg-rose-100 text-rose-700", ok: "bg-emerald-100 text-emerald-700", sous: "bg-sky-100 text-sky-700" };
export function JustesseBadge({ realise, trend3m, n_1, objectif, testid }) {
  const j = justesse(realise, trend3m, n_1, objectif);
  if (!j) return null;
  return <span data-testid={testid || "justesse-badge"} data-status={j.status} title={`Indice ${j.idx.toFixed(0)} %`} className={`px-1.5 py-0.5 rounded text-[10px] font-semibold whitespace-nowrap ${JUSTESSE_CLS[j.status]}`}>{j.label}</span>;
}

/* Agrégation d'un ensemble de lignes en un noeud */
export function sumRows(rows, fallbackAvg = 0) {
  const a = { realise: 0, objectif: 0, n_1: 0, lfl_r: 0, lfl_n1: 0, ca_14h: 0, trend3m: 0 };
  const cnt = {}; let tsum = 0, tn = 0;
  rows.forEach(r => { a.realise += r.realise; a.objectif += r.objectif; a.n_1 += r.n_1; a.lfl_r += r.lfl_r; a.lfl_n1 += r.lfl_n1; a.ca_14h += r.ca_14h; a.trend3m += r.trend3m || 0;
    if (r.weather) { const k = `${r.weather.emoji}|${r.weather.label}|${r.weather.cat || ""}`; cnt[k] = (cnt[k] || 0) + 1; if (r.weather.tmax != null) { tsum += r.weather.tmax; tn++; } } });
  const top = Object.entries(cnt).sort((x, y) => y[1] - x[1])[0];
  a.weather = top ? { emoji: top[0].split("|")[0], label: top[0].split("|")[1], cat: top[0].split("|")[2], tmax: tn ? tsum / tn : null, n: rows.length } : null;
  a.ecart = a.realise - a.objectif;
  a.perf = a.objectif ? a.realise / a.objectif : null;
  a.lfl = a.lfl_n1 ? a.lfl_r - a.lfl_n1 : null;
  a.lfl_pct = a.lfl_n1 ? (a.lfl_r - a.lfl_n1) / a.lfl_n1 : null;
  a.evo_n1 = a.n_1 ? (a.realise - a.n_1) / a.n_1 : null;
  // Projection : réalisé + rythme journalier moyen (jours réalisés) × jours restants (jours avec objectif sans réalisé, à venir)
  const today = new Date().toISOString().slice(0, 10);
  const byDate = {};
  rows.forEach(r => { const d = byDate[r.date] || (byDate[r.date] = { r: 0, o: 0 }); d.r += r.realise; d.o += r.objectif; });
  const dates = Object.keys(byDate);
  const done = dates.filter(d => byDate[d].r > 0);
  const left = dates.filter(d => byDate[d].r <= 0 && d > today).length;
  const avg = done.length ? a.realise / done.length : fallbackAvg;
  a.projection = (done.length || (left && fallbackAvg)) ? a.realise + avg * left : (left ? null : a.realise);
  a.projection_pct = a.projection != null && a.objectif ? (a.projection - a.objectif) / a.objectif : null;
  return a;
}

/* Construit l'arbre Mois → Semaine → Jour → (groupes) */
export function avgDay(rows) {
  const byDate = {};
  rows.forEach(r => { byDate[r.date] = (byDate[r.date] || 0) + r.realise; });
  const done = Object.values(byDate).filter(v => v > 0);
  return done.length ? done.reduce((a, b) => a + b, 0) / done.length : 0;
}

export function buildTree(rows, total, bySector = false) {
  const months = {};
  const gAvg = avgDay(rows);
  rows.forEach(r => {
    const mk = r.date.slice(0, 7);
    const m = months[mk] || (months[mk] = { id: mk, level: 0, label: `${MONTHS_FR[+r.date.slice(5, 7) - 1]} ${r.date.slice(0, 4)}`, rows: [] });
    m.rows.push(r);
  });
  const fin = (n, children) => {
    const a = sumRows(n.rows, n.level >= 1 ? gAvg * (new Set(n.rows.map(r => r.key)).size / Math.max(1, new Set(rows.map(r => r.key)).size)) : 0);
    return { ...n, ...a, poids: total ? a.realise / total : 0, children, nCorners: new Set(n.rows.map(r => r.key)).size };
  };
  const buildWeeks = (mrows, prefix, base) => {
    const weeks = {};
    mrows.forEach(r => {
      const w = weeks[r.semaine] || (weeks[r.semaine] = { id: `${prefix}-S${r.semaine}`, level: base, semaine: r.semaine, rows: [], days: {} });
      w.rows.push(r);
      const d = w.days[r.date] || (w.days[r.date] = { id: `${prefix}-${r.date}`, level: base + 1, date: r.date, label: dayLabel(r.date), rows: [], items: [] });
      d.rows.push(r); d.items.push(r);
    });
    return Object.values(weeks).sort((a, b) => a.semaine - b.semaine).map(w => {
      const dates = w.rows.map(r => r.date).sort();
      const wk = { ...w, label: `Semaine S${String(w.semaine).padStart(2, "0")}`, sub: `${shortDate(dates[0])} – ${shortDate(dates[dates.length - 1])}` };
      return fin(wk, Object.values(w.days).sort((a, b) => a.date.localeCompare(b.date)).map(d =>
        fin(d, d.items.length > 1 ? d.items.map(it => ({ id: `${d.id}-${it.key}`, level: base + 2, isItem: true, label: it.label, corner: it.label, rows: [it], ...sumRows([it], 0), poids: total ? it.realise / total : 0, children: [] })) : [])));
    });
  };
  return Object.values(months).sort((a, b) => a.id.localeCompare(b.id)).map(m => {
    if (!bySector) return fin(m, buildWeeks(m.rows, m.id, 1));
    const secs = {};
    m.rows.forEach(r => { const sN = secs[r.key] || (secs[r.key] = { id: `${m.id}-sec-${r.key}`, level: 1, isSector: true, label: r.label || r.key, rows: [] }); sN.rows.push(r); });
    return fin(m, Object.values(secs).sort((a, b) => a.label.localeCompare(b.label, "fr")).map(sN => fin(sN, buildWeeks(sN.rows, sN.id, 2))));
  });
}
